// extracted by mini-css-extract-plugin
export default {"biobar-title":"styles_biobar-title__73Q32","biobar-message":"styles_biobar-message__jlEBL","biobar-footer":"styles_biobar-footer__VeVG2"};